<template>
    <div class="details-card">
        <b-row v-if="showone == 'Consumption Return'">
            <b-col>
                <div class="field">
                    <label>Reason Name</label>
                    <Dropdown />
                </div>
            </b-col>
        </b-row>
        <b-row v-if="showone == 'Consumption Return'">
            <b-col>
                <div class="field">
                    <label>Date of Return</label>
                    <Datepicker />
                </div>
            </b-col>
        </b-row>
    </div>
</template>
  
<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import TextField from '../../../../components/FormComponents/TextInput.vue'
import Datepicker from '../../../../components/FormComponents/DatePicker.vue'



export default defineComponent({

    props: {
        showone: {
            type: String,
            default: ''
        }
    },

    components: {
        TextField,
        Datepicker
    },
    setup() {

        return {

        }
    }
})
</script>